import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PlusIcon } from "lucide-react";
import { useBooking } from "../contexts/BookingContext";
import { TitleUnderline } from "./TitleUnderline";
import { faqs } from "../data/faq";
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const {
    openBooking
  } = useBooking();
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map(f => ({
      "@type": "Question",
      name: f.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: f.answer
      }
    }))
  };
  return <section id="fragen" aria-labelledby="faq-title" className="flex w-full scroll-mt-24 items-center bg-cream-deep md:min-h-[calc(100svh-4rem)]" data-id="element-64" data-mp="240fd21gbn9vw">
      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(jsonLd)
    }} data-id="element-65" data-mp="so6387d6l9tv" />
      <div className="mx-auto grid w-full max-w-7xl gap-12 px-5 py-10 md:grid-cols-12 md:gap-8 md:px-10 md:py-6 lg:py-[3vh]" data-id="element-66" data-mp="nn8ok4rdqxx4">
        <div className="md:col-span-4" data-id="element-67" data-mp="pipp48o12v9m">
          {/* Label centred over the heading's own width. */}
          {/* Mobile & tablet: whole block centred. Desktop: left-aligned. */}
          <div className="mx-auto w-fit lg:mx-0" data-id="element-68" data-mp="fj8hhlp7u7b0">
            <p className="text-center text-xs uppercase tracking-[0.3em] text-bark" data-id="element-69" data-mp="kil5i9rtpkf6">Häufige Fragen</p>
            <h2 id="faq-title" className="mt-4 text-center font-serif lg:text-left text-4xl font-medium leading-tight text-espresso sm:text-5xl md:mt-3 md:text-3xl lg:mt-4 lg:text-5xl" data-id="element-70" data-mp="6rq2he409xji">
              Alles, was Du <TitleUnderline data-id="element-71" data-mp="3sywmjxfunw9y">wissen</TitleUnderline> solltest
            </h2>
          </div>
          <p className="mt-5 text-center text-lg font-light leading-relaxed text-cocoa md:mt-3 md:text-sm lg:text-left md:leading-snug lg:mt-5 lg:text-lg lg:leading-relaxed" data-id="element-72" data-mp="1s3q16w04lbr">
            Deine Frage ist nicht dabei? Sprich mich an, ich antworte Dir persönlich.
          </p>
          <button type="button" onClick={openBooking} className="mx-auto mt-8 flex w-fit items-center justify-center whitespace-nowrap rounded-full border border-bark bg-bark px-8 py-4 lg:mx-0 lg:inline-flex text-sm uppercase tracking-[0.18em] text-cream transition-colors duration-150 hover:border-bark-deep hover:bg-bark-deep md:mt-5 md:px-5 md:py-3 md:text-xs md:tracking-[0.12em] lg:mt-8 lg:px-8 lg:py-4 lg:text-sm lg:tracking-[0.18em]" data-id="element-73" data-mp="3o1o8o91qieei">
            Kostenloses Erstgespräch
          </button>
        </div>

        <ul className="border-t border-cream-line md:col-span-8 lg:col-span-7 lg:col-start-6" data-id="element-74" data-mp="28hngsfyuf4t5">
          {faqs.map((faq, i) => {
          const open = openIndex === i;
          const id = `faq-${i}`;
          return <li key={faq.question} className="border-b border-cream-line" data-id="element-75" data-mp="1zi0hbzpoc92q" data-mpi={i}>
                <h3 data-id="element-76" data-mp="s3xdhbfjskkk">
                  <button type="button" aria-expanded={open} aria-controls={`${id}-panel`} id={`${id}-button`} onClick={() => setOpenIndex(open ? null : i)} className="group flex w-full items-center justify-between gap-6 py-4 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-bark md:py-[1.5vh] lg:py-[1.9vh]" data-id="element-77" data-mp="s09kcde0m06d">
                    <span className="font-serif text-xl font-medium leading-snug text-espresso md:text-lg lg:text-2xl" data-id="element-78" data-mp="3dgang0v14tzf">
                      {faq.question}
                    </span>
                    <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full border transition-colors duration-150 ${open ? "border-bark bg-bark text-cream" : "border-espresso/30 text-espresso group-hover:border-bark group-hover:bg-bark group-hover:text-cream"}`} data-id="element-79" data-mp="3ncngqxmnx5tn">
                      <PlusIcon className={`h-4 w-4 transition-transform duration-200 ${open ? "rotate-45" : ""}`} aria-hidden="true" data-id="element-80" data-mp="220lzp79ybqxk" />
                    </span>
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-81" data-mp="1gn219notofvl">
                  {open && <motion.div id={`${id}-panel`} role="region" aria-labelledby={`${id}-button`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-82" data-mp="1bp0il3vb6ikn">
                      <p className="max-w-2xl pb-5 pr-14 font-light leading-relaxed text-cocoa" data-id="element-83" data-mp="58eokykrfzbg">{faq.answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}